/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/

import { Cycle } from "@src/app/model/cycle";
import { ActionColor, IFormAction } from "@src/app/shared/form/form.component";
import { CycleService } from "@src/app/modules/budget/cycle.service";
import { MyInjector } from "@src/app/app.module";
import { ConfirmDialogService } from "@src/app/shared/dialogs/confirmDialog";
import { map } from "rxjs/operators";

export class AccountantExportAction implements IFormAction {
    name = $localize`Accountants Export`;
    color: ActionColor = 'primary';
    show = true;
    icon = 'folder_zip';
    approvalNeeded = true;
    disabled = false;
    approvalText = $localize`Accountants Export?
    The accountants export gathers all the reports an accountant normally looks for at year end
    into a single zip file, which is attached to this cycle.
    The zip includes a _contents.txt listing everything in it, and flagging anything that did not
    reconcile.
    We will email you when the file is ready to collect.
    Normally you only do this once a year, at year end, for the accountants records`;
    tipText = 'Zipped export of all year end reports for your accountant';
    cycleSvc = MyInjector.instance.get(CycleService);
    cds = MyInjector.instance.get(ConfirmDialogService)

    action(cycle: Cycle) {
        return this.cycleSvc.statusChange(cycle, 'accountantExport').pipe(map((o) => {
            if (o) {
                this.cds.alert('Export being generated',
                    `Your export is being generated. It takes some time, so we will send you an email
                     when it is ready. You can then collect it from the attachments tab on this cycle.`)
            }

            return o;
        }));
    }

    setup() {
        this.show = true;
    }
}
